const InitialStateBsJourney = {
  previousScreen: 'NO_SCREEN_TO_SHOW',
  currentScreen: 'WELCOME_BS_SCREEN',
  // DOCS: show welcome screen, only be shown if user clicks I will do it later and comes back through clicking on fibe card
  showBSWelcomeScreen: true,
  bsSuccess: false,
  bsApproved: false,
  globalOverlayLoader: false,
  screenConstHistory: [],
  selectedBankObj: {},
  noOfStatement: 3,
  noOfMonthsToShow: 3,
  // DOCS: requiredStatements is array of months for which user got suspended. userBank is perfiosInfo of user comes from perfios
  requiredStatements: [null, null, null],
  userBank: {
    bankName: '',
    accNo: '',
  },
  bankStatementPassword: '',
  // DOCS: Flow type can be ONLINE or OFFLINE, used for moving back logic on Ack screen
  flowTypeEnum: '',
  comingBackFromPerfiosFlag: false,
  // DOCS: journey type can be SUSPEND, NORMAL, LIMIT_ENHANCE used in API Payload for journey type
  journeyTypeEnum: 'NORMAL',
  monthlyStatementErr: {
    isError: false,
    errorMsg: '',
  },
  ackScreen: {
    statusCode: '',
    statusMsg: '',
    statusDes: '',
    bgImg: '',
    fiboLottieJSON: '',
  },
  getBankAPICall: {
    response: {},
    isLoading: false,
    isError: false,
    isSuccess: false,
  },
  getPrefferedOptionsAPICall: {
    response: {},
    isLoading: false,
    isError: false,
    isSuccess: false,
  },
  perfiosOnlineBankingAPICall: {
    response: {},
    isLoading: false,
    isError: false,
    isSuccess: false,
  },
  bsOnlineTxnAPICall: {
    response: {},
    isLoading: false,
    isError: false,
    isSuccess: false,
  },
  bsVerifyTxnAPICall: {
    response: {},
    isLoading: false,
    isError: false,
    isSuccess: false,
  },
  saveBsDocUploadAPICall: {
    response: {},
    isLoading: false,
    isError: false,
    isSuccess: false,
  },
  s3FileUploadAPICall: {
    uploadFileResponses: [null, null, null, null],
    response: {},
    isLoading: false,
    isError: false,
    isSuccess: false,
  },
};

export default InitialStateBsJourney;
